// 慧声客服
<template>
  <el-row type="flex" justify="center" class="serviceBody">
    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="serviceBody_top">
      <!-- <img src="@/assets/img/huisheng_kefu/huisheng_kefu.png" /> -->
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
          <div data-aos="fade-right" class="serviceBody_top_text" :style="{'margin-left': isMobile ? '2em' : ''}">
            <div class="serviceBody_top_text_1">
              <span>智能客服机器人上线</span>
            </div>
            <div class="serviceBody_top_text_2">
              <p>以问题解决为导向，匹配多种业务场景的客服机器人为您服务</p>
            </div>
            <el-button type="text" class="serviceBody_top_text_btn" @click="showDialog">抢先报名体验产品</el-button>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <add-dialog v-if="showAddDialog" :SHOW.sync="showAddDialog"></add-dialog>
  </el-row>
</template>

<script>
import goProduce from "@/util/produce.js";
import AddDialog from "@/components/Dialog.vue";
import ResizeEvent from "@/components/resizeEvent"

export default {
  name: "service",
  components: {
    AddDialog,
  },
  mixins:[ResizeEvent],
  data() {
    return {
      showAddDialog: false,
      topHeight: "700px",
    };
  },
  created() {
    this.handleResize();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 报名体验产品
    goProduce,
    showDialog() {
      this.showAddDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.serviceBody {
  flex-flow: row wrap;
  .serviceBody_top {
    height: 700px;
    background: url("../../assets/img/huisheng_kefu/huisheng_kefu.png")
      no-repeat center;
    color: #fff;
    border-top: 1px solid white;
    position: relative;
    .serviceBody_top_text {
      // width: 60rem;
      height: 20.3rem;
      margin-top: 10.45rem;
      line-height: 4.5rem;
      .serviceBody_top_text_1 {
        // height: 7.5rem;
        font-size: 2.75rem;
        font-weight: lighter;
        span {
          height: 3.75rem;
          display: flex;
          flex: 1;
          white-space: nowrap;
          font-weight: lighter;
        }
      }
      .serviceBody_top_text_2 {
        height: 1.5rem;
        font-size: 1.2rem;
        margin-top: 4rem;
        line-height: 1.5rem;
        white-space: nowrap;
        font-weight: lighter;
      }
      .serviceBody_top_text_btn {
        width: 20rem;
        height: 3.8rem;
        margin-top: 3.95rem;
        background: rgba(255, 255, 255, 1);
        font-size: 1.8rem;
        color: rgba(32, 102, 233, 1);
        border-radius: 0;
        font-weight: lighter;
      }
    }
  }
  .serviceBody_center {
    // height: 37.5rem;
    border-top: 1px solid white;
    .serviceBody_center_top {
      width: 35rem;
      height: 1.75rem;
      font-size: 1.8rem;
      margin: 6.15rem auto 4.95rem;
      text-align: center;
    }
    .serviceBody_center_body {
      // width: 60rem;
      // height: 19rem;
      margin: 0 auto 6rem;
      flex-wrap: wrap;
      border-top: 1px solid white;
      // display: flex;
      background: rgba(255, 255, 255, 1);

      .serviceBody_center_body_item {
        // width: 20rem;
        // flex: 1;
        padding: 0 2.5rem;
        border-right: 1px solid #eee;
        img {
          display: block;
          width: 3.35rem;
          margin: 0 auto 2.65rem;
        }
        .title {
          // height: 3rem;
          font-size: 1.2rem;
          line-height: 1.5rem;
          margin: 0 auto 1.95rem;
          span {
            display: flex;
            flex: 1;
          }
        }
        .text {
          // height: 7.3rem;
          font-size: 0.7rem;
          line-height: 24px;
          p {
            margin-bottom: 1rem;
            strong {
              font-weight: 600 !important;
            }
          }
        }
        @media only screen and (max-width: 997px) {
          width: 100% !important;
          padding: 2em;
          margin: 0 2em 4em;
          box-shadow: 1px 1px 10px rgba($color: #000000, $alpha: 0.4);
        }
      }
      & div:last-child {
        border-right: none;
      }
    }
  }
  .serviceBody_bottom {
    // height: 55rem;
    width: 100%;
    background: rgba(247, 248, 252, 1);
    border-top: 1px solid white;
    padding-bottom: 7.25rem;
    .title {
      margin: 6.15rem auto 4.95rem;
      font-size: 1.8rem;
      text-align: center;
    }
    .body {
      // width: 65rem;
      // height: 35rem;
      flex-flow: row wrap;
      // margin: 0 auto;
      // display: flex;
      .body_item {
        width: 17.5rem;
        margin-bottom: 4em;
        // height: 35rem;
        // margin: 0 1.875rem;
        // flex: 1;
        background-color: #fff;
        box-shadow: 1px 1px 10px rgba($color: #000000, $alpha: 0.4);
        color: black;
        @media only screen and (max-width: 997px) {
          width: 100% !important;
        }

        img {
          height: 6.7rem;
          display: block;
          margin: 3rem auto;
        }
        .item_bottom {
          margin: 0 2.45rem;
          & > span {
            display: block;
            font-size: 1.8rem;
            margin-bottom: 2.7rem;
          }
          .item_bottom_text {
            margin-bottom: 2.15rem;
            font-weight: 400;
            span {
              font-size: 0.9rem;
              font-weight: 400;
              line-height: 2.55rem;
              p {
                display: inline-block;
                width: 0.5rem;
                height: 0.5rem;

                margin-right: 1rem;
                background-color: #5772fe;
                border-radius: 50%;
              }
            }

            p {
              font-size: 0.7rem;
              line-height: 24px;
            }
            .text_list {
              font-size: 0.7rem;
              line-height: 24px;
              display: flex;
              span {
                display: block;
                float: left;
                width: 0.2rem;
                height: 0.2rem;
                margin: 0.5rem 1rem 0.25rem 0.1rem;
                background: #999999;
                border-radius: 50%;
              }
              p {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 997px) and (max-width: 1199px) {
  .serviceBody_top {
    height: 500px !important;
    background-position: center;
  }
}
@media only screen and (max-width: 1600px) and (min-width: 1200px) {
  .serviceBody_top {
    height: 600px !important;
    background-position: center;
  }
}
@media only screen and (max-width: 996px) {
  .serviceBody_top {
    height: 300px !important;
    background-position: center;
    background-size: auto 300px !important;
    .serviceBody_top_text {
      margin-top: 50px !important;
      .serviceBody_top_text_1 {
        font-size: 2rem;
      }
    }
  }
}
</style>
<style >
.serviceBody_center_body_item .title span strong {
  color: #5772fe;
  font-weight: 600;
}
.serviceBody_center_body_item .text p strong {
  font-weight: 600;
}
</style>